/* DoctorSol logo — gebruikt de officiële SVG (img/doctorsol-logo.svg).
   `inverted` is behouden voor backwards-compatibility maar de SVG bevat
   z'n eigen kleuren, dus we wisselen alleen tinten op de filter. */
export default function LogoText({ className = "", size = "md", inverted = false }) {
  const sizes = {
    sm: "h-7",      // ~28px
    md: "h-9",      // ~36px
    lg: "h-12",     // ~48px
    xl: "h-16 sm:h-20",
  };
  // Wanneer op een donkere achtergrond ("inverted"): de tekst-delen lichten op via invert/brightness
  const filter = inverted ? "brightness(0) invert(1)" : undefined;

  return (
    <img
      src="/img/doctorsol-logo.svg"
      alt="DoctorSol"
      className={`${sizes[size]} w-auto select-none ${className}`}
      draggable={false}
      style={filter ? { filter, opacity: 0.95 } : undefined}
    />
  );
}
